import React, {FC, useState} from 'react';

import {Trans} from '../../libs/shared/helpers/src/internationalization/react';
import {useInitialEffect} from '../../libs/shared/helpers/src/react/hooks/useEffectHelpers';
import {Handler} from '../../libs/shared/helpers/src/react/reactHelpers';
import {
  RelativeDateTimeFormatsEnum,
  RelativeDateTimeFormatter,
} from '../../srcCommon/formatters/dateTime/relativeDateTimeFormatter';
import {useAppSelector} from '../helpers/reduxHelpers';
import {redirectToSignin} from '../services/browser';
import {registerHttpErrorHandlers} from '../services/http/http';
import {getSessionIdleTimeout} from '../store/data/company/companySelectors';
import {AlertDialog} from './common/dialogs/alertDialog';

/*
 * Component.
 */

export const SessionTimeoutDialog: FC = () => {
  const [showTimeoutDialog, setShowTimeoutDialog] = useState(false);
  const [showMaxSessionsDialog, setShowMaxSessionsDialog] = useState(false);
  const sessionTimeout = useAppSelector(getSessionIdleTimeout);

  useInitialEffect(() => {
    registerHttpErrorHandlers({
      onSessionTimeout: () => setShowTimeoutDialog(true),
      onSessionsMaxReached: () => setShowMaxSessionsDialog(true),
    });
  });

  if (showMaxSessionsDialog) {
    return renderMaxSessionsDialog(redirectToSignin);
  }

  if (showTimeoutDialog) {
    return renderTimeoutDialog(redirectToSignin, sessionTimeout);
  }

  return null;
};

function renderIdleTimeout(value: number) {
  return (
    <RelativeDateTimeFormatter
      format={RelativeDateTimeFormatsEnum.LONG}
      shouldNotRefresh
      value={Date.now() + value}
    />
  );
}

function renderMaxSessionsDialog(onRequestClose: Handler) {
  return (
    <AlertDialog
      title={<Trans id="dialog-sessionexpired-title">Session expired</Trans>}
      onRequestClose={onRequestClose}
    >
      <Trans id="dialog-maxsessions-content">
        You have exceeded the maximum number of allowed sessions on your account.
      </Trans>
    </AlertDialog>
  );
}

function renderTimeoutDialog(onRequestClose: Handler, idleTimeout: number) {
  return (
    <AlertDialog
      title={<Trans id="dialog-sessionexpired-title">Session expired</Trans>}
      onRequestClose={onRequestClose}
    >
      <Trans id="dialog-sessionexpired-content">
        Per your company&apos;s preferences you have been logged out due to inactivity for more than{' '}
        {renderIdleTimeout(idleTimeout)}.
      </Trans>
    </AlertDialog>
  );
}
